import * as React from 'react';

import { Button, ButtonTheme } from '@cian/components';

import { BSCDialogForm } from './bsc_add_request_dialog';

const style = require('./bsc_add_request.css');

class BSCAddRequest extends React.Component<object, {isVisible: Boolean}> {
  public constructor() {
    super();

    this.state = {
      isVisible: false,
    };
  }

  public render() {
    return (
      <div className={style['cf_bsc_serp-add_request_item']}>
        <div>
          <div className={style['cf_bsc_serp-add_request_image']}>
          </div>
          <div className={style['cf_bsc_serp-add_request_description']}>
            <div className={style['cf_bsc_serp-add_request_description_header']}>Как попасть в каталог?</div>
            <div className={style['cf_bsc_serp-add_request_description_body']}>
              Хотите стать официальным представителем или добавить<br/>
              ваш Бизнес-Центр в каталог БЦ? Отправьте заявку.
            </div>
          </div>
          <div className={style['cf_bsc_serp-add_request_action']}>
            <Button
              theme={ButtonTheme.BLUE_SOLID}
              onClick={() => this.setState({isVisible: !this.state.isVisible})}
              >Отправить заявку</Button>
          </div>
            {
              this.state.isVisible &&
              <BSCDialogForm
                onRequestSend={() => this.setState({isVisible: !this.state.isVisible})}
              />
            }
        </div>
      </div>
    );
  }
}

export default BSCAddRequest;



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/components/bsc_add_request/bsc_add_request.tsx